export default "__VITE_ASSET__O0xKItdW__"